import { useQuery } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import qs from 'qs';

import { WorkflowStage } from 'components/pages/viewApplication/ViewApplication';
import { LanguageOption } from 'components/pages/viewApplication/AssestmentLanguageSelector/AssestmentLanguageSelector';

import { endpoints } from 'config';
import instance from 'api';

type ProngLanguage = { languageId: number; languageName: string };

type Prong = { prongId: number; languages: ProngLanguage[] };

type AvailableLanguagesResponse = {
  status: '1' | '0', id: number, errors: any[], details: {
    prongLanguages: Prong[]
  }
};

const traverseStagesForProngIds = (stages: WorkflowStage[]) => {
  const stageItems = stages.map((stageItem) => stageItem.stageItems).flat().filter(Boolean);

  return stageItems.map((stageItem) => {
    if (stageItem.templates) {
      return stageItem.templates.map(template => template.assessmentProngID)
        .filter((prongId): prongId is number => prongId !== null && prongId !== undefined);
    } else {
      return [];
    }
  }).flat();
}

const fetchAvailableLanguagesByProngId = async (stages: WorkflowStage[]) => {
  const prongIds = traverseStagesForProngIds(stages);

  const config: AxiosRequestConfig = {
    withCredentials: true,
    params: {
      prongId: prongIds,
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  };

  const { data } = await instance.get<AvailableLanguagesResponse>(`${endpoints.jobApplication.getAvailableLanguagesByProngId}`, config);

  const prongIdToLanguages = data.details.prongLanguages.reduce((acc: Record<number, LanguageOption[]>, prong) => {
    const availableLanguages = prong.languages.map(language => ({ label: language.languageName, value: String(language.languageId) }));
    if (availableLanguages.length) {
      acc[prong.prongId] = availableLanguages

      return acc;
    }

    return acc;
  }, {});

  return prongIdToLanguages
};

const useAvailableLanguagesByProngId = (stages: WorkflowStage[], enabled: boolean) => {
  return useQuery({ queryKey: ['availableLanguages', stages], queryFn: () => fetchAvailableLanguagesByProngId(stages), enabled: enabled });
};

export default useAvailableLanguagesByProngId;